<!-- src/app/change-log/change-log.component.html -->
<div class="changeLog">
  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Control de Cambios
        </span>
      </h3>
    </div>
  </div>

  <!-- user, date, company and action info -->
  <div class="row">
    <div class="col-6">
      <p><strong>Usuario:</strong> {{ user.username }}</p>
      <p><strong>Empresa:</strong> {{ company.name }}</p>
    </div>
    <div class="col-6 text-right">
      <p><strong>Fecha:</strong> {{ date | date:'medium' }}</p>
      <p><strong>Acción:</strong> {{ action }}</p>
    </div>
  </div>

  <!-- navigation buttons -->
  <div class="row">
    <div class="col-6 text-left">
      <button mat-button class="btn btn-manax" (click)="navigate(-1)" [disabled]="logIndex <= 0">Anterior</button>
    </div>
    <div class="col-6 text-right">
      <button mat-button class="btn btn-manax" (click)="navigate(1)" [disabled]="logIndex >= totalLogs - 1">Siguiente</button>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12">
      <div *ngFor="let change of changes; let i = index">
        <h3>{{ change.entity }}</h3>
        <div class="row">
          <div class="col-6">
            <div *ngFor="let key of properties[i] | keyvalue">
              <div *ngIf="getChangeType(properties[i], key.key) !== 'added'" [ngClass]="getChangeType(properties[i], key.key)">
                <strong>{{ key.key }}</strong>: {{ getValue(change.before, key.key) }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div *ngFor="let key of properties[i] | keyvalue">
              <div *ngIf="getChangeType(properties[i], key.key) !== 'removed'" [ngClass]="getChangeType(properties[i], key.key)">
                <strong>{{ key.key }}</strong>: {{ getValue(change.after, key.key) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
